import React from "react";
import "./Hero.css";
import dark_arrow from '../../assets/edusity/dark-arrow.png'

const Hero = () => {
  return (
    <div className="hero container">
      <div className="hero-text">
        <h1> Inspiring Faith and Community for a Brighter Tomorrow </h1>
        <p>
          Our mission is to nurture faith, strengthen community bonds, and guide
          individuals on their spiritual journey with compassion, wisdom, and
          purpose.</p>
          
          <button className="btn"> Explore More <img src={dark_arrow} alt=""/> </button>
        
      </div>
    </div>
  );
};

export default Hero;
